import React from 'react';
import { BaseField } from 'react/components/fields';
import PropTypes from 'prop-types';

const renderFieldContent = ({
  id,
  input,
  options,
  disabled
}) => (
  <div id={id}>
    {
      options.map((option) => (
        <div className="radioGroupOption" key={option.value}>
          <div className="radioGroupOptionWrapper">
            <input
              id={`${id}-${option.value}`}
              name={id}
              value={option.value}
              type="radio"
              checked={input.value === option.value}
              onChange={(e) => input.onChange(e.target.value)}
              disabled={disabled}
            />
            <label htmlFor={`${id}-${option.value}`}>
              {Monet.I18n.getResourcesByKey(option.label)}
            </label>
          </div>
          { option.optionHint && (input.value === option.value) && <div className="radioGroupOptionHint">{Monet.I18n.getResourcesByKey(option.optionHint)}</div>}
        </div>
      ))
    }
  </div>
);

const gridFormatter = ({ label, name, options }) => ({
  id: name,
  name,
  label,
  fieldDomains: options.map((option) => ({ description: option.label, ...option })),
  type: 'RADIOGROUP'
});

const RadioGroupField = (props) => {
  const { defaultValue, ...remainingProps } = props;
  return (
    <BaseField
      fieldClassName="radioGroup"
      renderFieldContent={renderFieldContent}
      defaultValue={defaultValue}
      gridFormatter={gridFormatter}
      {...remainingProps}
    />
  );
};

renderFieldContent.propTypes = {
  id: PropTypes.string.isRequired,
  input: PropTypes.object.isRequired,
  options: PropTypes.object.isRequired,
  disabled: PropTypes.bool
};

renderFieldContent.defaultProps = {
  disabled: false
};

RadioGroupField.propTypes = {
  defaultValue: PropTypes.string
};

RadioGroupField.defaultProps = {
  defaultValue: null
};

export default RadioGroupField;
